// src/components/practice/tasks/writing/layouts/TelcB2FormalLetterLayout.jsx
import React from 'react';
import { marked } from 'marked';
import { parseAdvertisementContent } from '../parsers/advertisementParser.js';

const TelcB2FormalLetterLayout = ({ scenario, inputContent, guidingPoints, task }) => {
    // Parse the advertisement content
    const parsedAd = parseAdvertisementContent(inputContent);

    return (
        <>
            {/* Scenario introduction */}
            {scenario && (
                <div className="mb-6">
                    <p className="text-gray-800 leading-relaxed italic">
                        {task?.inputType === 'advertisement' ? 'Sie finden in einer Zeitschrift folgende Anzeige:' : 'Lesen Sie folgende Werbeanzeige:'}
                    </p>
                </div>
            )}

            {/* Advertisement Box - Formatted like exam paper */}
            {parsedAd && (
                <div className="border-2 border-gray-400 rounded-lg bg-gray-100 p-6 my-6">
                    {/* Company Name - Bold Header */}
                    {parsedAd.companyName && (
                        <h3 className="font-bold text-lg text-gray-900 mb-3">
                            {parsedAd.companyName}
                        </h3>
                    )}

                    {/* Intro Text */}
                    {parsedAd.intro && (
                        <p className="text-gray-800 leading-relaxed mb-4">
                            {parsedAd.intro}
                        </p>
                    )}

                    {/* Sections with Headers and Bullet Points */}
                    {parsedAd.sections.map((section, idx) => (
                        <div key={idx} className="mb-4">
                            {/* Section Header */}
                            {section.header && (
                                <p className="font-bold text-gray-900 mb-2">
                                    {section.header}
                                </p>
                            )}

                            {/* Section Items as Bullet List */}
                            {section.items.length > 0 && (
                                <ul className="list-disc ml-5 space-y-1 text-gray-800">
                                    {section.items.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}

                    {/* Footer/Contact Info */}
                    {parsedAd.footer.length > 0 && (
                        <div className="mt-4 pt-3 border-t border-gray-400">
                            {parsedAd.footer.map((line, idx) => (
                                <p key={idx} className="text-gray-800 text-sm">
                                    {line}
                                </p>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* Scenario text - after the advertisement */}
            {scenario && (
                <div className="mb-6">
                    <p className="text-gray-800 leading-relaxed">
                        {scenario}
                    </p>
                </div>
            )}

            {/* Instructions */}
            <div className="mb-4">
                <p className="text-gray-800 leading-relaxed italic">
                    {scenario && scenario.includes('beschweren')
                        ? 'Schreiben Sie einen Brief, in dem Sie sich beschweren.'
                        : 'Schreiben Sie einen Brief, in dem Sie um mehr Informationen bitten.'}
                </p>
            </div>

            {/* Guiding Points Section */}
            {guidingPoints && guidingPoints.length > 0 && (
                <div className="my-6">
                    <p className="text-gray-800 mb-2">
                        <span className="font-normal">Behandeln Sie darin entweder</span>
                    </p>
                    <p className="text-gray-800 mb-2">
                        <span className="italic">a)</span> <span className="font-normal">mindestens drei der folgenden Punkte</span>
                    </p>
                    <p className="text-gray-800 mb-3">
                        <span className="italic">oder</span>
                    </p>
                    <p className="text-gray-800 mb-3">
                        <span className="italic">b)</span> <span className="font-normal">mindestens zwei der folgenden Punkte und einen weiteren Aspekt Ihrer Wahl.</span>
                    </p>

                    {/* Bullet points */}
                    <ul className="list-disc ml-6 space-y-2 text-gray-800">
                        {guidingPoints.map((point, index) => (
                            <li key={index} className="pl-2">
                                {point.text || point}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Final Instructions with Bold Keywords */}
            <div className="my-6 text-gray-800 leading-relaxed">
                <p className="mb-2">
                    Bevor Sie den Brief schreiben, überlegen Sie sich eine passende{' '}
                    <strong>Reihenfolge der Punkte</strong>, eine passende{' '}
                    <strong>Einleitung</strong> und einen passenden{' '}
                    <strong>Schluss</strong>. Vergessen Sie nicht{' '}
                    <strong>Ihren Absender</strong>, <strong>die Anschrift</strong>,{' '}
                    <strong>Datum</strong>, <strong>Betreffzeile</strong>,{' '}
                    <strong>Anrede und Schlussformel</strong>.
                </p>
            </div>

            {/* Word Count */}
            <div className="my-4">
                <p className="text-gray-800 italic">
                    Schreiben Sie <strong>mindestens 150 Wörter</strong>.
                </p>
            </div>
        </>
    );
};

export default TelcB2FormalLetterLayout;